import { detailedProfit, codRtoProfit } from "../../lib/calcEngine";
import { formatCurrency, formatPct } from "../../lib/format";

export const ScenarioTable = ({ calc, values }) => {
  const { mode, varKey, steps } = calc.scenario;

  let rows;
  if (mode === "rto") {
    rows = steps.map((rate) => {
      const r = codRtoProfit({ ...values, rtoRatePct: rate });
      return {
        key: rate,
        head: `${rate}%`,
        current: Math.abs(rate - values.rtoRatePct) < 0.001,
        profit: r.netProfit,
        secondary: formatCurrency(r.profitPerDeliveredOrder),
      };
    });
  } else {
    const base = values[varKey] || 0;
    rows = steps.map((offset) => {
      const price = base + offset;
      const r = detailedProfit({ ...values, [varKey]: price });
      return {
        key: offset,
        head: formatCurrency(price),
        current: offset === 0,
        profit: r.netProfit,
        secondary: formatPct(r.marginPct),
      };
    });
  }

  const headLabel = mode === "rto" ? "RTO rate" : "Selling price";
  const secLabel = mode === "rto" ? "Profit / delivered" : "Margin";

  return (
    <div className="rounded-xl border border-border bg-card" data-testid="scenario-table">
      <div className="border-b border-border px-5 py-4">
        <h3 className="font-display text-lg font-semibold">Scenario analysis</h3>
        <p className="text-sm text-muted-foreground">
          {mode === "rto"
            ? "How your RTO rate changes overall profit."
            : "How changing your selling price changes profit per order."}
        </p>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border text-left text-xs uppercase tracking-wide text-muted-foreground">
              <th className="px-5 py-3 font-semibold">{headLabel}</th>
              <th className="px-5 py-3 text-right font-semibold">Net profit</th>
              <th className="px-5 py-3 text-right font-semibold">{secLabel}</th>
            </tr>
          </thead>
          <tbody className="tabular">
            {rows.map((row) => (
              <tr
                key={row.key}
                className={`border-b border-border/60 last:border-0 ${row.current ? "bg-accent/60" : ""}`}
                data-testid={`scenario-row-${row.key}`}
              >
                <td className="px-5 py-3 font-medium">
                  {row.head} {row.current && <span className="ml-1 text-xs text-primary">(current)</span>}
                </td>
                <td className={`px-5 py-3 text-right font-mono font-semibold ${row.profit < 0 ? "text-red-600" : "text-emerald-600"}`}>
                  {formatCurrency(row.profit)}
                </td>
                <td className="px-5 py-3 text-right font-mono text-muted-foreground">{row.secondary}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
